import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedPlural } from "react-intl";
import { generateDestinationTitle } from "app/utils/productUtils";
import AppGlobalsContext from "app/AppGlobalsContext";
import ProductAddress from "app/pages/.shared/ProductAddress/ProductAddress";

import "./ProductSummary.scss";

const ProductSummary = ({
	booking = {},
	ficheProduit = {},
	displayAccommodationNights = true,
	displayAccommodationAddress = false,
}) => {
	const { shop } = useContext(AppGlobalsContext);
	const hasLocationInfo = ficheProduit?.geography || ficheProduit?.region || ficheProduit?.resort;
	const accommodationNights = booking?.accommodationNights || booking?.duration?.value;

	return (
		<div data-testid="product-summary" className="product-summary">
			{displayAccommodationAddress ? (
				<ProductAddress ficheProduit={ficheProduit} />
			) : (
				<>
					{hasLocationInfo && (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.REGULAR}
							className="product-summary__label"
							data-testid="product-summary-location"
						>
							{generateDestinationTitle(shop, ficheProduit, false)}
						</Typography>
					)}
				</>
			)}

			{displayAccommodationNights && accommodationNights && accommodationNights > 0 && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.REGULAR}
					className="product-summary__label"
					data-testid="product-summary-accommodation-nights"
				>
					<FormattedPlural
						data-testid="night-count"
						value={accommodationNights}
						one={
							<FormattedMessage
								id="general.duration.singular"
								values={{
									duration: accommodationNights,
								}}
							>
								{accommodationNights}
							</FormattedMessage>
						}
						other={
							<FormattedMessage
								id="general.duration.plural"
								values={{
									duration: accommodationNights,
								}}
							>
								{accommodationNights}
							</FormattedMessage>
						}
					/>
				</Typography>
			)}
		</div>
	);
};

ProductSummary.propTypes = {
	booking: PropTypes.object,
	ficheProduit: PropTypes.object,
	displayAccommodationNights: PropTypes.bool,
	displayAccommodationAddress: PropTypes.bool,
};

export default memo(ProductSummary);
